import { render, staticRenderFns } from "./ModalLaborRegime.vue?vue&type=template&id=787b7b48"
import script from "./ModalLaborRegime.vue?vue&type=script&lang=js"
export * from "./ModalLaborRegime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports